var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".notFound[data-v-1d95b06e]{background-image:url(" + escape(require("../assets/img/backgrounds/4.jpg")) + ");background-repeat:no-repeat;max-width:inherit;background-position:50%;background-size:cover;min-height:100vh}.notFound .text[data-v-1d95b06e]{padding-top:13em;color:#fff;font-weight:700;margin-right:3em}", ""]);

// exports
